import { lazy } from 'react';
import AcbaLogo from '../../assets/images/logo/ACBA-Logo.png';
import ScbaLogo from '../../assets/images/logo/SCCBA-logo.png';
import MNLogo from '../../assets/images/logo/MNLogo.png';
import EpbcLogo from '../../assets/images/logo/EPBC-Logo.png';

const MiscRoutes = [
    {
        path: '/accept_or_decline_referral/:referralToken',
        component: lazy(() =>
            import('../../pages/Misc/AcceptOrDeclineReferral'),
        ),
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'pending_referral',
        },
    },
    {
        path: '/accept_or_decline_referral_acba/:referralToken',
        layout: 'auto',
        showNavbar: true,
        showFooter: false,
        showLogin: false,
        showMenus: false,
        logo: AcbaLogo,
        showPoweredBy: true,
        component: lazy(() =>
            import('../../pages/Misc/AcceptOrDeclineReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'pending_referral',
        },
    },
    {
        path: '/accept_or_decline_referral_scba/:referralToken',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        logo: ScbaLogo,
        navbarLink: 'https://www.sccba.com/lawyer-referral-service/',
        showPoweredBy: true,
        showFooter: false,
        component: lazy(() =>
            import('../../pages/Misc/AcceptOrDeclineReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'pending_referral',
        },
    },
    {
        path: '/accept_or_decline_referral_mnlrs/:referralToken',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showLogo: false,
        navbarTextLogo: 'Minnesota Lawyer Referral and Information Service',
        navbarTextLogoStyle: {
            color: '#0693e3',
        },
        navbarLink: 'https://www.mnlawyerreferral.org/',
        showPoweredBy: true,
        showFooter: false,
        component: lazy(() =>
            import('../../pages/Misc/AcceptOrDeclineReferral'),
        ),
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'pending_referral',
        },
    },
    {
        path: '/reschedule_appointment',
        component: lazy(() => import('../../pages/Misc/RescheduleAppointment')),
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        meta: {
            publicRoute: true,
            action: 'accept',
            resource: 'referral',
        },
    },
    {
        path: '/cancel_appointment',
        component: lazy(() => import('../../pages/Misc/CancelAppointment')),
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'appointments',
        },
    },
    {
        path: '/cancel_appointment_acba',
        component: lazy(() => import('../../pages/Misc/CancelAppointment')),
        layout: 'auto',
        showNavbar: true,
        showFooter: false,
        showLogin: false,
        showMenus: false,
        logo: AcbaLogo,
        showPoweredBy: true,
        meta: {
            publicRoute: true,
            action: 'read',
            resource: 'appointments',
        },
    },
    {
        path: '/client_survey',
        layout: 'auto',
        showNavbar: true,
        showFooter: true,
        showLogin: false,
        showMenus: false,
        showPoweredBy: true,
        component: lazy(() => import('../../pages/Misc/Survey')),
        meta: {
            publicRoute: true,
        },
    },
    {
        path: '/ecba_client_survey',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        showLogo: false,
        showPoweredBy: true,
        navbarTextLogo: 'ECBA',
        navbarTextLogoStyle: {
            color: '#BE884C',
        },
        showFooter: true,
        footerType: 'ecba',
        component: lazy(() => import('../../pages/Misc/Survey')),
        meta: {
            publicRoute: true,
        },
    },
    {
        path: '/scba_client_survey',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        logo: ScbaLogo,
        navbarLink: 'https://www.sccba.com/lawyer-referral-service/',
        showPoweredBy: true,
        showFooter: true,
        footerType: 'scba',
        component: lazy(() => import('../../pages/Misc/Survey')),
        meta: {
            publicRoute: true,
        },
    },
    {
        path: '/mnlrs_client_survey',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        logo: MNLogo,
        navbarLink: 'https://www.mnlawyerreferral.org/',
        showPoweredBy: true,
        showFooter: true,
        footerType: 'mnlrs',
        component: lazy(() => import('../../pages/Misc/Survey')),
        meta: {
            publicRoute: true,
        },
    },
    {
        path: '/epbc_client_survey',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        logo: EpbcLogo,
        navbarLink: 'https://www.elpasocountybar.org/site/public-resources',
        showPoweredBy: true,
        showFooter: true,
        footerType: 'epbc',
        component: lazy(() => import('../../pages/Misc/Survey')),
        meta: {
            publicRoute: true,
        },
    },
    {
        path: '/accept_task/:taskId',
        layout: 'auto',
        showNavbar: true,
        showLogin: false,
        showMenus: false,
        logo: AcbaLogo,
        showPoweredBy: true,
        showFooter: true,
        footerType: 'acba',
        component: lazy(() => import('../../pages/Misc/AcceptTask')),
        meta: {
            publicRoute: true,
        },
    },
];

export default MiscRoutes;
